import { Column } from 'devextreme-react/data-grid';
import { getCellFormat } from './utils/getCellFormat';
import { ReportColumnProps } from './types';
import { DataType } from 'devextreme/common';


export function ReportColumn({ column, children, allowGrouping, allowSorting, dateFormat, groupCellContent }: Readonly<ReportColumnProps & { allowGrouping?: boolean; allowSorting?: boolean; dateFormat?: string }>): JSX.Element {
    return (
        <Column
            allowGrouping={allowGrouping}
            alignment="left"
            key={column.title}
            dataField={column.name}
            caption={column.title}
            allowSorting={allowSorting}
            dataType={column.type === 'currency' ? 'number' : column.type as DataType | undefined} // TODO: test with currency fields 
            format={getCellFormat(column.type, dateFormat)}
            width={column.width}
            groupIndex={column.groupIndex}
            groupCellRender={groupCellContent}
            visible={column.visible !== false} // default visible, unless explicitly set to false (eg. SLA Performance Report has some columns with visible: false)
        >
            {children}
        </Column>
    );
}
